module.exports = __webpack_public_path__ + "static/img/bg-19.fa8ae2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-19.png
// module id = LT7v
// module chunks = 0